//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faCoinVertical } from '@fortawesome/pro-regular-svg-icons';
import { formatDistanceToNowStrict } from 'date-fns';
import AiToolsMixin from '@motionelements/core/src/components/mixins/ai-tools.mixin.js';

export default {
  name: 'PredictionsTable',
  mixins: [AiToolsMixin],
  components: {
    LoaderSpin: () => import('@motionelements/core/src/components/ui/LoaderSpin.vue'),
  },
  props: {
    predictions: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      faCoinVertical,
      fields: [
        {
          key: 'id',
          label: 'ID',
        },
        {
          key: 'model',
          label: this.$t('term.tool'),
          tdClass: 'text-nowrap',
        },
        {
          key: 'createdAt',
          label: this.$t('term.created'),
        },
        {
          key: 'status',
          label: this.$t('term.status'),
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'amount',
          label: this.$t('term.coins'),
          thClass: 'text-nowrap',
        },
        {
          key: 'view',
          label: '',
        },
      ],
    };
  },
  computed: {
    getTool() {
      return (prediction) => {
        let model = _.get(prediction, 'model', '');
        model = model.includes('video_upscale') ? 'video_upscale_2x' : model;
        return [...this.aiTools, ...this.aiToolsMaintained].find(tool => model.includes(tool.model));
      };
    },
    predictionToolTitle() {
      return (prediction) => _.get(this.getTool(prediction), 'heading');
    },
    predictionLink() {
      return (prediction) => {
        const tool = this.getTool(prediction);
        let link = tool ? `${_.get(tool, 'link')}?prediction_id=${prediction.id}` : null;
        if (prediction.model === 'business_illustration') {
          let style = _.get(prediction, 'input.style', 'business');
          switch (style) {
            case 'black_jack_color':
              style = 'black-jack-color';
              break;
            case 'black_jack_monochrome':
              style = 'black-jack';
              break;
            // no default
          }
          link = tool && style ? `/illustration/${style}?prediction_id=${prediction.id}` : null;
          return link ? this.$link(link).aiUrl() : '';
        }
        if (this.externalTools.includes(tool.id)) {
          return this.$link(link).aiUrl();
        }
        return link ? this.$link(link).fullPath() : '';
      };
    },
    status() {
      return (prediction) => _.get(prediction, 'status');
    },
    createdAt() {
      return (prediction) => {
        const pastDate = new Date(prediction.createdAt * 1000);
        return formatDistanceToNowStrict(pastDate, { addSuffix: true });
      };
    },
    statusText() {
      return (prediction) => {
        switch (this.status(prediction)) {
          case 'succeeded':
            return this.$t('status.succeeded');
          case 'canceled':
            return this.$t('status.canceled');
          case 'failed':
            return this.$t('status.failed');
          default:
            return this.$t('term.generating');
        }
      };
    },
    statusBadgeClass() {
      return (prediction) => {
        switch (this.status(prediction)) {
          case 'succeeded':
            return 'badge-success';
          case 'canceled':
            return 'badge-secondary';
          case 'failed':
            return 'badge-danger';
          default:
            return 'badge-secondary';
        }
      };
    },
  },
};
